import {
  EntityIndicador,
  emptyIndicador,
} from '~entity/entity-indicador/entity-indicador.model';
import { CardGroupVo } from '~model/vo/card-group-vo';

export interface EntityCard extends CardGroupVo {
  config: EntityIndicador;
}

export const emptyCards = (): EntityCard[] => [
  {
    id: 'distancia',
    descricao: 'Distância',
    itens: [
      {
        descricao: 'Roteiro',
        principal: 0,
        unidade: 'km',
        secundario: 0,
        unidadeSecundario: '%',
        icon: 'fa-route' ?? 'roundabout_right',
      },
    ],
    config: emptyIndicador(),
  },
  {
    id: 'ocupacao',
    descricao: 'Ocupação',
    itens: [
      {
        descricao: 'Peso',
        principal: 0,
        unidade: '%',
        icon: 'fa-weight' ?? 'balance',
      },
      {
        descricao: 'Volume',
        principal: 0,
        unidade: '%',
        icon: 'fa-object-group' ?? 'highlight_alt',
      },
      {
        descricao: 'Cubagem',
        principal: 0,
        unidade: '%',
        icon: 'fa-cube' ?? 'view_in_ar',
      },
    ],
    config: emptyIndicador(),
  },
  {
    id: 'atraso',
    descricao: 'Atrasos',
    itens: [
      {
        descricao: 'Ocorridos',
        principal: 0,
        icon: 'fa-calendar-times' ?? 'more_time',
      },
      {
        descricao: 'Previstos',
        principal: 0,
        icon: 'fa-clock' ?? 'watch_later',
      },
    ],
    config: emptyIndicador(),
  },
  {
    id: 'rotas',
    descricao: 'Rotas',
    itens: [
      {
        descricao: 'Ativas',
        principal: 0,
        icon: 'fa-toggle-on' ?? 'directions',
      },
      {
        descricao: 'Canceladas',
        principal: 0,
        icon: 'fa-toggle-off' ?? 'directions_off',
      },
    ],
    config: emptyIndicador(),
  },
  {
    id: 'veiculos',
    descricao: 'Veículos',
    itens: [
      { descricao: 'Próprios', principal: 0, icon: 'fa-truck' ?? 'no_crash' },
      { descricao: 'Terceiros', principal: 0, icon: 'fa-taxi' ?? 'car_rental' },
    ],
    config: emptyIndicador(),
  },
  {
    id: 'pedidos',
    descricao: 'Pedidos',
    itens: [
      {
        descricao: 'A Atender',
        principal: 0,
        secundario: 0,
        unidadeSecundario: '%',
        icon: 'fa-clipboard-list' ?? 'pending_actions',
        sempreVisivel: true,
      },
      {
        descricao: 'Sucessos',
        principal: 0,
        secundario: 0,
        unidadeSecundario: '%',
        icon: 'assignment_turned_in',
      },
      {
        descricao: 'Insucessos',
        principal: 0,
        secundario: 0,
        unidadeSecundario: '%',
        icon: 'assignment_late',
      },
      {
        descricao: 'Cancelados',
        principal: 0,
        secundario: 0,
        unidadeSecundario: '%',
        icon: 'fa-window-close' ?? 'assignment_return',
      },
      {
        descricao: 'Órfãos',
        principal: 0,
        icon: 'fa-undo' ?? 'assignment_returned',
      },
    ],
    config: emptyIndicador(),
  },
  {
    id: 'visitas',
    descricao: 'Visitas',
    itens: [
      {
        descricao: 'Adicionadas',
        principal: 0,
        icon: 'fa-plus-circle' ?? 'add_circle_outline',
      },
      {
        descricao: 'Canceladas',
        principal: 0,
        icon: 'fa-minus-circle' ?? 'cancel',
      },
      {
        descricao: 'Remanejadas',
        principal: 0,
        icon: 'fa-exchange-alt' ?? 'sync_alt',
      },
    ],
    config: emptyIndicador(),
  },
];
